import React from "react";
import "./StaticInfoPage.css";

function CreditosPage() {
  return (
    <div className="static-page">
      <div className="static-page__inner">
        <h1 className="static-page__title">Créditos</h1>
        <p className="static-page__subtitle">
          Investigación, análisis temático y gestión del sistema
        </p>

        <div className="static-card">
          <div className="static-card__accent" aria-hidden />
          <ul className="creditos-list">
            <li>
              <strong>Geógrafa MSc. Ana Milena Sarabia Gómez:</strong>{" "}
              Supervisión y apoyo en la gestión del sistema de información,
              investigación histórica.
            </li>
            <li>
              <strong>Geógrafa MSc. Esp. Diana Rocío Barbosa Castro:</strong>{" "}
              Investigación histórica y apoyo en la gestión del sistema de
              información.
            </li>
            <li>
              <strong>Geóloga Laura María Arcila:</strong> Investigación
              histórica.
            </li>
            <li>
              <strong>Historiador Ricardo Andrés Blanco Quijano:</strong>{" "}
              Investigación histórica.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default CreditosPage;
